import startBg from '../assets/images/startBg.webp';
import rocket from '../assets/images/rocket.webp';
import pathStart from '../assets/images/pathStart.webp';
import logo from "../assets/images/logo.svg";

import bgLevel1 from '../assets/images/bgLevel1.webp';
import pathLong from '../assets/images/pathLong.webp';
import bgLevel1Desk from '../assets/images/bgLevel1Desk.webp';
import hold1 from '../assets/images/hold1.webp';
import hold2 from '../assets/images/hold2.webp';
import hold3 from '../assets/images/hold3.webp';
import hold4 from '../assets/images/hold4.webp';
import hold5 from '../assets/images/hold5.webp';
import hold6 from '../assets/images/hold6.webp';
import part1 from '../assets/images/part1.webp';
import part2 from '../assets/images/part2.webp';
import part3 from '../assets/images/part3.webp';
import part4 from '../assets/images/part4.webp';
import part5 from '../assets/images/part5.webp';
import part6 from '../assets/images/part6.webp';
import progressBar from '../assets/images/progressBar.webp';
import progressBarFull from '../assets/images/progressBarFull.webp';
import progressIcon from '../assets/images/progressIcon.webp';

import level2Bg from "../assets/images/level2Bg.webp";
import stationLevel2 from '../assets/images/stationLevel2.webp';
import oil1 from '../assets/images/oil1.webp';
import oil2 from '../assets/images/oil2.webp';

import level3Bg from "../assets/images/level3Bg.webp";
import level3Oil from '../assets/images/level3Oil.webp';
import level3BoxOil from '../assets/images/level3BoxOil.webp';
import level3RocketBox from '../assets/images/level3Rocket_box.webp';
import level3Rocket from '../assets/images/level3Rocket.webp';
import level3Finish from '../assets/images/level3Finish.webp';

import level4Bg from "../assets/images/level4Bg.webp";
import pathSm from "../assets/images/pathSm.webp";
import aster1 from "../assets/images/aster1.webp";
import aster2 from "../assets/images/aster2.webp";
import aster3 from "../assets/images/aster3.webp";
import crush from "../assets/images/crush.webp";
import trash1 from "../assets/images/trash1.webp";
import trash2 from "../assets/images/trash2.webp";
import trash3 from "../assets/images/trash3.webp";

import level5Bg from "../assets/images/level5Bg.webp";

export const level1images = [
    bgLevel1, hold1, part1, 
    hold2, part2, hold3, part3, hold4, part4, 
    hold5,  part5, hold6, part6, pathLong, bgLevel1Desk, progressBar,
    progressBarFull, progressIcon,
];
export const level2images = [level2Bg, stationLevel2, oil1, oil2];
export const level3images = [level3Bg, level3Oil, level3BoxOil, level3RocketBox, level3Rocket];
export const level4images = [level4Bg, pathSm, aster1, aster2, aster3, crush, trash1, trash2, trash3 ];

export const images = [[startBg, logo, rocket, pathStart], level1images, level2images, level3images, [level3Finish], level4images, [level5Bg]];
